/* eslint-disable */
export class Atualizacao {
  constructor () {
    this.src = ''
    this.name = ''

  }
}
